import {
  type DefaultDomainConfig,
  type DomainConfigMap,
  DOMAINS,
} from '~/domains/core';
import ASBCSocialsJSON from '~/domains/core/infrastructure/data/social/asbc.json';
import AsbisSocialsJSON from '~/domains/core/infrastructure/data/social/asbis.json';
import { logoConfig } from '~/domains/core/infrastructure/data/logo/logoConfig.ts';
import { vuetifyThemeConfig } from '~/domains/core/infrastructure/data/theme';

interface ReturnDomainConfig {
  config: DomainConfigMap;
  defaultConfig: DefaultDomainConfig;
}

export const domainConfig = (): ReturnDomainConfig => {
  const config: DomainConfigMap = {
    [DOMAINS.ASBC]: {
      id: DOMAINS.ASBC,
      logo: logoConfig[DOMAINS.ASBC],
      favicon: '/favicon-asbc.ico',
      loginFormTitle: 'components.loginForm.asbc.title',
      socials: ASBCSocialsJSON,
      footerCopyright: (year: number) =>
        `© ${year} ASBC LLC. All rights reserved.`,
      theme: vuetifyThemeConfig.ASBC.name,
      fonts: {
        bodyFontFamily: `'SF Pro Display', sans-serif`,
        sources: ['sf-pro-display'],
      },
    },
    [DOMAINS.BREEZY]: {
      id: DOMAINS.BREEZY,
      logo: logoConfig[DOMAINS.BREEZY],
      loginFormTitle: 'components.loginForm.breezy.title',
      favicon: '/favicon-breezy.ico',
      theme: vuetifyThemeConfig.BREEZY.name,
      fonts: {
        bodyFontFamily: `'Arimo', sans-serif`,
        sources: ['arimo'],
      },
    },
    [DOMAINS.ASBIS]: {
      id: DOMAINS.ASBIS,
      logo: logoConfig[DOMAINS.ASBIS],
      favicon: '/favicon-asbis.ico',
      loginFormTitle: 'components.loginForm.title',
      socials: AsbisSocialsJSON,
      footerCopyright: (year: number) =>
        `© 1995 - ${year}, ASBISc Enterprises Plc.`,
      theme: vuetifyThemeConfig.ASBIS.name,
      fonts: {
        bodyFontFamily: `'Arimo', sans-serif`,
        sources: ['arimo'],
      },
    },
  };

  const defaultConfig = config[DOMAINS.ASBIS] as DefaultDomainConfig;

  return {
    config,
    defaultConfig,
  };
};
